import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55484abe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-valuenow", "aria-valuemin", "aria-valuemax"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vertical-slider", { focused: $setup.focused }]),
    ref: "slider",
    onPointerdown: $setup.onPointerDown,
    onKeydown: $setup.onKeyDown,
    tabindex: 0,
    role: "slider",
    "aria-valuenow": $setup.value,
    "aria-valuemin": $setup.min,
    "aria-valuemax": $setup.max,
    "aria-orientation": "vertical",
    "aria-label": "수직 슬라이더",
    onFocus: $setup.onFocus,
    onBlur: $setup.onBlur
  }, [
    _createElementVNode("div", {
      class: "thumb",
      style: _normalizeStyle({ bottom: $setup.thumbBottom })
    }, null, 4 /* STYLE */)
  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}